module.exports = __webpack_public_path__ + "img/ISO14001.9c2b3a6a.png";